<div appBsModal #myProjectSelectionModal="bs-modal" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="myLargeModalLabel" aria-hidden="true" [config]="{backdrop: 'static'}">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    <span>{{"SelectProject" | localize}}</span>
                </h4>
            </div>
            <div class="modal-body">
                <table class="table table-borderless table-md" *ngIf="this.myProjects?.length > 0">
                    <tbody>
                        <ng-container *ngFor="let project of this.myProjects">
                            <tr>
                                <td>
                                    {{ project.name }}
                                </td>
                                <td>
                                    <a class="btn btn-link" (click)="setCurrentProject(project)">{{"Select" | localize}}</a>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
                <div *ngIf="initialProjectPopup && this.myProjects?.length == 0">
                    <h5 class="modal-title">
                        <span class="highlight-message">{{"NoProjectAvailable" | localize}}</span>. <span>{{"NoProjectContactAdmin" | localize}}</span>.
                    </h5>
                </div>
            </div>
        </div>
    </div>
</div>